import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "detail-top" }
const _hoisted_2 = { class: "time" }
const _hoisted_3 = { style: {"display":"inline-block","max-width":"50rem"} }
const _hoisted_4 = { class: "detail-container" }
const _hoisted_5 = { class: "detail-content" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "prompt-section" }
const _hoisted_15 = { class: "prompt" }

import { ref, onMounted, watchEffect, computed } from "vue";
import { code, siteId } from "@/services/config";
import Loading from "@/components/Loading/index.vue";
import dayjs from "dayjs";


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailLayout',
  props: [
  "timeValue",
  "currentNewsId",
  "requestApi",
  "currentVersionName",
],
  emits: ["closeInfo"],
  setup(__props, { emit: __emit }) {

const scrollContainer = ref(null); // 创建 ref 引用

const props = __props;
const emit = __emit;

const articleInfo = ref({}); //文章详情
const loading = ref(false); // 是否加载中

//返回主页面
const backPage = () => {
  emit("closeInfo");
};

//获取文章详情
const getArticleInfo = async () => {
  loading.value = true;
  const params = {
    code,
    id: props.currentNewsId,
    siteId,
  };
  const res = await props.requestApi.articleId(params);
  if (res.status == 200) {
    articleInfo.value = res.obj;
    loading.value = false;
    scrollContainer.value?.scrollTo({ top: 0, behavior: "smooth" });
  }
};

const convertStylePxToRem = (htmlString: string) => {
  // 匹配style属性中的px值
  return htmlString?.replace(/style="([^"]*)"/g, (match, styleContent) => {
    const convertedStyle = styleContent.replace(
      /(\d+)px/g,
      (_: any, pxValue: any) => {
        return parseInt(pxValue) / 10 + "rem";
      }
    );
    return 'style="' + convertedStyle + '"';
  });
};

watchEffect(() => {
  if (props.currentNewsId) {
    getArticleInfo();
  }
});
onMounted(() => {
  getArticleInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Lock = _resolveComponent("Lock")!

  return (_openBlock(), _createElementBlock("div", {
    class: "detail-box",
    style: _normalizeStyle({ 'user-select': articleInfo.value.status ? 'text' : 'none' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        class: "btn",
        onClick: backPage
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, { color: "#437ef5" }, {
            default: _withCtx(() => [
              _createVNode(_component_ArrowLeft)
            ]),
            _: 1
          }),
          _cache[0] || (_cache[0] = _createTextVNode(" 返回"))
        ]),
        _: 1,
        __: [0]
      }),
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" 当前期次：" + _toDisplayString(_unref(dayjs)(__props.timeValue).format("YYYY-MM-DD")) + " ", 1),
        _createElementVNode("span", null, [
          _cache[1] || (_cache[1] = _createTextVNode("     ")),
          _createElementVNode("span", _hoisted_3, _toDisplayString(__props.currentVersionName), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Loading, { loading: loading.value }, null, 8, ["loading"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "detail-subtitle",
            innerHTML: convertStylePxToRem(articleInfo.value?.articleVo?.pretitle)
          }, null, 8, _hoisted_7),
          _createElementVNode("div", {
            class: "detail-title",
            innerHTML: convertStylePxToRem(articleInfo.value?.articleVo?.title)
          }, null, 8, _hoisted_8),
          _createElementVNode("div", {
            class: "detail-subtitle",
            innerHTML: convertStylePxToRem(articleInfo.value?.articleVo?.subtitle)
          }, null, 8, _hoisted_9),
          _createElementVNode("div", {
            class: "detail-subtitle",
            innerHTML: convertStylePxToRem(articleInfo.value?.articleVo?.author)
          }, null, 8, _hoisted_10)
        ]),
        _createElementVNode("div", {
          class: "content",
          ref_key: "scrollContainer",
          ref: scrollContainer
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articleInfo.value?.articleVo?.picList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "detail-pic",
              key: index
            }, [
              _createElementVNode("img", {
                src: item.url
              }, null, 8, _hoisted_11),
              _createElementVNode("p", {
                innerHTML: convertStylePxToRem(item.picText)
              }, null, 8, _hoisted_12)
            ]))
          }), 128)),
          _createElementVNode("div", {
            class: "detail-text",
            innerHTML: convertStylePxToRem(articleInfo.value?.articleVo?.content)
          }, null, 8, _hoisted_13)
        ], 512)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[2] || (_cache[2] = _createTextVNode(" 请扫描右侧小程序二维码进行订阅，展示全部内容 ")),
          _createVNode(_component_el_icon, { style: {"margin-left":"0.2rem","font-size":"1.3rem"} }, {
            default: _withCtx(() => [
              _createVNode(_component_Lock)
            ]),
            _: 1
          })
        ])
      ], 512), [
        [_vShow, !articleInfo.value.status]
      ])
    ])
  ], 4))
}
}

})